export const attendanceLogs = {
  returnAt: {
    returnSuccessfully: 'Return Uniform successfully!',
  },
}
